import React, { useCallback } from 'react'
import Search from '../Icon/icons/Search/index'

export interface SearchInputProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder: string
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onSubmit?: () => void
  className?: string
  children?: React.ReactNode
  ariaLabel?: string
}

function SearchInput ({
  value,
  onChange,
  placeholder,
  onKeyDown,
  onSubmit,
  className,
  children,
  ariaLabel,
}: SearchInputProps) {
  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onSubmit) {
      onSubmit()
    }
    if (onKeyDown) {
      onKeyDown(e)
    }
  }, [onSubmit, onKeyDown])

  const rootClassName = className
    ? `search-input ${className}`
    : 'search-input'

  return (
    <div className={rootClassName}>
      <Search />
      <input
        type="text"
        className="search-input__field"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        aria-label={ariaLabel || placeholder}
      />
      {children}
    </div>
  )
}

export default SearchInput
